<div
  style="
    position: absolute;
    height: -webkit-fill-available;
    width: -webkit-fill-available;
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
  "
>
  <app-home></app-home>
</div>
